export enum OrderingType {
  ASC = "ascend",
  DESC = "descend",
}

export interface OrderingProp {
  [column: string]: OrderingType;
}
